import { graphql, navigate } from "gatsby"
import React from "react"
import Link from "../components/link"
import dateToString from "../utils/date-to-string"
import classNames from "../utils/classnames"
import formatTimeRange from "../utils/format-time-range"
import EventListItem from "../components/event-list-item"

interface ISliceProps {
  data: Queries.ImportantDatesSliceQuery
  horizontal?: boolean
}

const ImportantDates = ({
  data,
  horizontal = false,
}: ISliceProps): JSX.Element => (
  // console.log(`ImportantDates`, horizontal)
  <>
    <h2
      className={classNames(
        `font-bold text-2xl text-black`,
        horizontal ? `text-center mt-8` : ``
      )}
    >
      Important dates
    </h2>
    <ul
      className={classNames(
        `p-0 mb-8`,
        horizontal ? `grid grid-cols-3 gap-4` : ``
      )}
    >
      {data?.allImportantDates?.nodes?.map(node => (
        <li
          className={classNames(
            `before:content-none p-0`,
            horizontal ? `col-span-3 lg:col-span-1` : ``
          )}
          key={node.id}
        >
          <EventListItem node={node} horizontal={horizontal} />
        </li>
      ))}
    </ul>
    <Link
      to="/admissions/important-dates"
      className="bg-blue text-white px-4 py-2 no-underline hover:bg-green hover:text-white"
    >
      See all important dates
    </Link>
  </>
)

export default ImportantDates

export const query = graphql`
  query ImportantDatesSlice {
    allImportantDates: allWpEvent(
      filter: {
        futureEvent: { eq: true }
        eventCategories: {
          nodes: { elemMatch: { slug: { in: ["important-dates"] } } }
        }
      }
      limit: 6
      sort: { eventStartDate: ASC }
    ) {
      nodes {
        ...EventItemFields
      }
    }
  }
`
